// extracted by mini-css-extract-plugin
export default {"regHeaderName":"RegisterAgent_regHeaderName__OA9pa"};